export const environment = {
  production: false,
  name: 'staging',

  apiUrl: 'https://staging.api.yoshu.app/v1',
  socketUrl: 'https://staging.api.yoshu.app',

  tenantId: 'coty-18qm6',
  analyticsTenantId: 'c4e3add3-d312-4f5f-9133-24333c643ae5',
  firebase: {
    apiKey: 'AIzaSyCDf1EdCj7sevm4-jQB13StpRD6sUO6ssg',
    authDomain: 'yoshu-authentification-staging.firebaseapp.com',
    projectId: 'yoshu-authentification-staging',
    storageBucket: 'yoshu-authentification-staging.firebasestorage.app',
    messagingSenderId: '975978410660',
    appId: '1:975978410660:web:71d27eb6d8ef2f40772c31',
    measurementId: 'G-CTJF15NYNP'
  },

  features: {
    'module.free-mode': true,
    'module.admin': true,
    'module.admin.analytics': true,
    'module.admin.datasets': true,
    'module.admin.domains': true,
    'bot-response.avatar': 'yoshu_v2'
  }
}
